export const verifyRecaptcha = async (recaptchaToken) => {
  const FASTLY_URL = process.env.FASTLY_URL || ""
  const response = await fetch(`${FASTLY_URL}/recaptcha`, {
    method: "POST",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
    body: `response=${recaptchaToken}`,
  })
  return await response.json()
}

export const resetRecaptcha = (recaptchaRef) => {
  recaptchaRef.current.reset()
  recaptchaRef.current.execute()
  const recaptchaBadge = document.querySelector(".grecaptcha-badge")
  recaptchaBadge && (recaptchaBadge.style.bottom = 0)
}
